module.exports = __webpack_public_path__ + "static/media/NPNTServicesActive.b030fd7b.svg";